export const wir = {
  callBackRequest: 'Rückruf anfordern',
  freeTestMonth: 'Gratis Testmonat sichern',
  newCustomerMainTitle: 'JETZT NEUE AUFTRÄGE<br /> MIT WIR SICHERN!',
  newCustomerMainSubtitle: '1´000 CHF Starterpaket <b>mit 100% WIR</b> bezahlen',
  newCustomerTitle: 'HausHeld-Neukunden&shy;aktion',
  newCustomerText:
    'Finden Sie einfacher neue Aufträge mit Ihrem persönlichen Kundengenerator von Hausheld.ch! Nutzen Sie kostenlos und unverbindlich die einmonatige Testphase und erhalten 3 Gratisanfragen. Die Testphase endet automatisch. Im Anschluss können Sie mit 100% WIR Ihr Starterpaket erwerben.',
  testingTitle:
    'In drei einfachen Schritten nach der gratis Testphase mit WIR neue Aufträge sichern',
  testingSubtitle1: 'Für 100% WIR jetzt Ihr persönliches Starterpaket sichern',
  testingText1:
    'Das Starterpaket umfasst entweder 500 CHF oder 1000 CHF als Guthaben für geprüfte HausHeld-Leads (preise pro Lead für 19 CHF je nach Branche)',
  testingSubtitle2:
    'Rund 10 bis 20 geprüfte Anfragen von Haus-Eigentümern erhalten und Aufträge sichern',
  testingText2: 'Sie definieren die Art der gewünschten Anfragen und erhalten passende Leads',
  testingSubtitle3: 'Dauerhauft Aufträge sichern und mit WIR bezahlen',
  testingText3:
    'Steuern Sie zu 100% flexibel, wie viele Anfragen Sie erhalten möchten und bezahlen Sie die Leads mit 20% WIR',
  advantageTitle: 'Ihre Vorteile auf einen Blick',
  advantageTitle1: 'Passende Kundenanfragen',
  advantageText1:
    'Sie erhalten nur Anfragen, die zu Ihrem Betrieb passen. Sie bestimmen für welche Projekte und aus welcher Region Sie Kunden­anfragen erhalten möchten. Wir senden Ihnen ausschliesslich Kunden­profile, welche zu diesen Angaben passen.',
  advantageTitle2: 'Faire Auftragsquoten',
  advantageText2:
    'Wir leiten die Kunden­anfragen an höchstens drei passende Handwerks­partner aus unserem Partner­netzwerk weiter. Dement­sprechend bieten wir Ihnen ein faires Wettbewerbs­umfeld, um Aufträge und Neukunden zu gewinnen.',
  advantageTitle3: 'Hochwertige Anfragen',
  advantageText3:
    'Unser internes Service­team kontaktiert die Anfrager vor der Weiter­leitung an Sie, um die Anfragen zu Validieren und die Projekt­angaben zu vervoll­ständigen. Sie profitieren von qualitativ hochwertigen und geprüften Kunden­anfragen.',
  faq: 'Häufig gestellte Fragen',
  faqWirQuestion1: 'Ist die einmonatige Testphase wirklich gratis?',
  faqWirAnswer1:
    'Ja, Sie erhalten in der einmonatigen Testphase bis zu 3 Gratisanfragen genau passend zu Ihrem Leistungsangebot. Es fallen keine Kosten für diese Anfragen an und die Testphase endet automatisch. Sie haben damit die Möglichkeit, unsere Dienstleistung kostenlos und unverbindlich zu testen.',
  faqWirQuestion2: 'Was beinhaltet die 100% WIR Neukundenpromotion?',
  faqWirAnswer2:
    'Das Starterpaket für 500 WIR entspricht 500 CHF Guthaben ebenso das 1000 WIR Paket, 1000 CHF entspricht. Dafür erhalten Sie rund 10-20 (je nach Branche) geprüfte, für Sie passende Renovationsanfragen. Nachdem Sie Ihr Guthaben aufgebraucht haben, erhalten Sie eine monatliche Rechnung, welche Sie zu 20% mit WIR bezahlen können. Das Starterpaket können Sie auch im Anschluss an die einmonatige Testphase erwerben.',
  faqWirQuestion3: 'Wie funktioniert die Partnerschaft? Wie viel kosten die Leads?',
  faqWirAnswer3:
    'Sie wählen ein monatliches Marketingbudget aus und erhalten bis zum Erreichen dieser Budgetgrenze hochwertige und passende Kundenanfragen. Ein geprüfter Lead kostet ab 19 CHF (je nach Branche und geschätztem Auftragsvolumen).',
  faqWirQuestion4: 'Welche Leads muss ich bezahlen? Welche Kosten kommen auf mich zu?',
  faqWirAnswer4:
    'Wir stellen sicher, dass es sich um echte Anfragen handelt und die Anfrager auch erreichbar sind. Sie bezahlen nur die ausgewiesenen Leadpreise für die Leads, die Sie auch tatsächlich erhalten haben. Die Gebühr ist unabhängig vom Erfolgsfall (Auftrag) fällig. Es fallen keinerlei sonstige Kosten, wie z. B. Grund- oder Aufschaltungsgebühren, an.',
  faqWirQuestion5: 'Gibt es in der aktiven Partnerschaft Kündigungsfristen?',
  faqWirAnswer5:
    'Nein, Sie können jederzeit den Leaderhalt pausieren oder kündigen. Eine einfache Mail genügt.',
  faqWirQuestion6: 'Welche Anbieter dürfen mitmachen?',
  faqWirAnswer6:
    'Wir arbeiten ausschliesslich mit Qualitätsbetrieben aus der Schweiz zusammen. Zudem benötigt die Firma einen zeitgemässen Webauftritt sowie das Leistungsangebot muss sich mit unseren Gewerken und Dienstleistungen decken.',
  howItWorksTitle: 'So funktioniert HausHeld',
  howItWorks1: 'Kunden beschreiben online ihre Bedürfnisse mit allen angebotsrelevanten Daten',
  howItWorks2: 'Wir kontaktieren den Kunden, prüfen das Kaufinteresse und erfassen weitere Daten',
  howItWorks3:
    'Sie erhalten perfekt auf Ihren Betrieb passende Anfragen per Mail, beraten den Kunden und offerieren',
  callBackRequestTitle: 'Jetzt unabhängiges Beratungsgespräch anfordern',
  callBackRequestText:
    'Gerne berät Sie einer unserer Kundenbetreuer in einem kurzen unverbindlichen Telefongespräch, erklärt Ihnen wie die Plattform HausHeld.ch funktioniert und wie eine Zusammenarbeit aussehen könnte.',
  formCompany: 'Firma',
  formName: 'Name',
  formPhone: 'Telefonnummer',
  formDate: 'Datum für Kontaktaufnahme:',
  wirDate: 'Beste Erreichbarkeit (Tageszeit, Datum, ...)',
  wirFormTitle: 'Jetzt anmelden und gratis Testmonat sichern',
  wirFormSubtitle:
    'Registrieren Sie sich jetzt und profitieren Sie als Neukunde von der kostenlosen, einmonatigen Testphase. Sie erhalten 3 Gratisanfragen.',
  successText: 'Rückruf wurde angefragt.',
}

export const wirForm = {
  title: 'WIR-KMU erfassen',
  subTitle: 'Kontaktdaten',
  counselor: 'WIR-Berater',
  uid: 'UID-KMU',
  wirFormFormSuccessMessage: 'Die Anfrage wurde erfolgreich übermittelt.',
}
